export function temOverflowHorizontal(scrollWidth, clientWidth) {
    return Number(scrollWidth) > Number(clientWidth) + 1;
}

export function deveFixarCabecalho({ top, bottom, alturaCabecalho }) {
    return Number(top) < 0 && Number(bottom) > Number(alturaCabecalho) + 8;
}

// Caso 20 (QA 25/09): o passo antigo era 80% da grade (~836px em 1280, ~1330px em 1920) — a
// grade "pulava" uma tela inteira e o operador perdia a referência. Agora: 40% da faixa ROLÁVEL
// (grade menos as colunas fixas Ações/Descrição), o que dá 2–4 colunas de valor por toque e
// mantém ~60% do que estava à vista como referência. Mínimo de 120px (~1 coluna) em telas estreitas.
export function passoScrollHorizontal(larguraVisivel, limiteFixo = 0) {
    const faixaRolavel = Math.max(0, (Number(larguraVisivel) || 0) - (Number(limiteFixo) || 0));
    return Math.max(120, Math.round(faixaRolavel * 0.4));
}

// Destino das setas ←/→: anda um passo e, se houver início de coluna a até meio passo do alvo,
// encaixa nele (a coluna para inteira logo após as fixas, sem ficar cortada ao meio).
// bordasColunas = bordas esquerdas das colunas no espaço do CONTEÚDO da grade; limite = scrollWidth − clientWidth.
export function destinoScrollHorizontal({ atual, direcao, larguraVisivel, limiteFixo = 0, limite, bordasColunas = [] }) {
    const maximo = Math.max(0, Number(limite) || 0);
    const origem = Math.min(maximo, Math.max(0, Number(atual) || 0));
    const passo = passoScrollHorizontal(larguraVisivel, limiteFixo);
    const bruto = origem + (direcao < 0 ? -passo : passo);
    // Tolerância de arredondamento (a coluna fixa mede 1px diferente parada × rolada): até 2px
    // de uma borda conta como "já na coluna", e bordas a até 2px das pontas viram 0 / fim.
    const TOLERANCIA = 2;
    const candidatos = bordasColunas
        .map((borda) => Math.round(Number(borda) - (Number(limiteFixo) || 0)))
        .filter((valor) => Number.isFinite(valor) && valor >= -TOLERANCIA && valor <= maximo + TOLERANCIA)
        .map((valor) => (valor <= TOLERANCIA ? 0 : (valor >= maximo - TOLERANCIA ? maximo : valor)))
        .filter((valor) => (direcao < 0 ? valor < origem - TOLERANCIA : valor > origem + TOLERANCIA))
        .filter((valor) => Math.abs(valor - bruto) <= passo / 2);
    const encaixe = candidatos.sort((a, b) => Math.abs(a - bruto) - Math.abs(b - bruto))[0];
    let destino = Math.min(maximo, Math.max(0, Math.round(encaixe === undefined ? bruto : encaixe)));
    if (destino <= TOLERANCIA) destino = 0;
    if (destino >= maximo - TOLERANCIA) destino = maximo;
    return destino;
}

// A barra fixa tem botões e texto ao redor dela, por isso sua área visível não
// é igual à da grade. Esta largura mantém os dois limites de scroll idênticos.
export function larguraConteudoProxyParaMesmoLimite({ larguraVisivelProxy, scrollWidthGrade, larguraVisivelGrade }) {
    const proxy = Math.max(0, Number(larguraVisivelProxy) || 0);
    const limiteGrade = Math.max(0, (Number(scrollWidthGrade) || 0) - (Number(larguraVisivelGrade) || 0));

    return proxy + limiteGrade;
}

// Caso 20: o navegador pode reservar espaço (gutter/borda do scrollbar) e a barra parava 9–10px
// antes da grade. Depois de aplicar a largura, compara o limite REAL da barra com o da grade e
// devolve a largura corrigida (0 = nada a corrigir).
export function correcaoLarguraProxy({ larguraConteudoAtual, limiteRealProxy, limiteGrade }) {
    const diferenca = Math.round((Number(limiteGrade) || 0) - (Number(limiteRealProxy) || 0));
    return diferenca === 0 ? 0 : Math.max(0, (Number(larguraConteudoAtual) || 0) + diferenca);
}

export function alvoEhControleInterativo(alvo) {
    if (!alvo || typeof alvo.closest !== 'function') {
        return false;
    }

    return Boolean(alvo.closest('input, textarea, select, button, a, .access-react-select, [contenteditable="true"], [role="combobox"], [role="listbox"], [role="option"]'));
}

// Item 13 ("Mostrar campo"): scrollLeft da grade para o campo ficar visível sem ficar sob as
// colunas fixas (Ações/Descrição travadas) e, se couber, com a coluna Descrição de Custos da
// mesma linha à vista. Coordenadas no espaço do CONTEÚDO da grade (independem do scroll atual):
// campoEsq/campoDir = bordas do campo; descricaoEsq = borda esquerda da Descrição (null se ela
// já é fixa); limiteFixo = largura ocupada à esquerda pelas colunas fixas; larguraVisivel =
// clientWidth da grade; scrollMax = scrollWidth - clientWidth.
export function scrollLeftParaCampo({ campoEsq, campoDir, descricaoEsq = null, limiteFixo = 0, larguraVisivel, scrollMax, margem = 16 }) {
    const limitar = (valor) => Math.min(Math.max(0, Math.round(valor)), Math.max(0, Math.round(scrollMax)));
    const cabe = (scroll) => campoEsq - scroll >= limiteFixo && campoDir - scroll <= larguraVisivel;
    if (descricaoEsq !== null && descricaoEsq !== undefined) {
        const comDescricao = limitar(descricaoEsq - limiteFixo);
        if (cabe(comDescricao)) return comDescricao;
    }
    // Não coube com a Descrição: o campo encosta à esquerda, logo após as colunas fixas.
    return limitar(campoEsq - limiteFixo - margem);
}

// Item 13 ("Mostrar campo"): quanto rolar a PÁGINA (px; positivo = para baixo) para o campo ficar na
// área útil da janela — abaixo do que é fixo no topo (barra do sistema / cabeçalho espelho da grade)
// e acima da pilha fixa do rodapé (avisos + barra de rolagem horizontal + botões). Centralizar na
// janela inteira deixava o campo atrás do alerta em telas baixas (1280×720 / 1366×768).
// Coordenadas de viewport (getBoundingClientRect). Área menor que o campo + margens: cola no topo útil.
export function deslocamentoVerticalParaCampo({ campoTopo, campoBase, topoUtil, baseUtil, margem = 12 }) {
    const alturaUtil = baseUtil - topoUtil;
    const alturaCampo = campoBase - campoTopo;
    if (alturaUtil < alturaCampo + 2 * margem) return Math.round(campoTopo - (topoUtil + margem));
    return Math.round((campoTopo + campoBase) / 2 - (topoUtil + baseUtil) / 2);
}

// Limites da área útil a partir das medidas da tela: topo = maior borda inferior entre os fixos do
// topo; base = menor borda superior entre os fixos do rodapé que estão visíveis (null = ausente).
export function areaUtilVertical({ alturaJanela, basesFixasTopo = [], toposFixosRodape = [] }) {
    const validos = (lista) => lista.filter((valor) => Number.isFinite(valor));
    const topoUtil = Math.max(0, ...validos(basesFixasTopo));
    const baseUtil = Math.min(alturaJanela, ...validos(toposFixosRodape).filter((valor) => valor > topoUtil));
    return { topoUtil, baseUtil };
}
